var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6616 0.260939C8.42812 0.0583741 8.11894 -0.0336687 7.81225 0.0111089L4.25847 0.518943C3.73642 0.593217 3.34302 1.04703 3.34302 1.57406V5.97754C3.04521 5.79701 2.67846 5.68613 2.27689 5.68613C1.29711 5.68613 0.5 6.32368 0.5 7.10764C0.5 7.8916 1.29711 8.52915 2.27689 8.52915C3.25666 8.52915 4.05377 7.8916 4.05377 7.10764V3.45223L8.31831 2.84311V4.91141C8.0205 4.73088 7.65375 4.62 7.25217 4.62C6.2724 4.62 5.47529 5.25755 5.47529 6.04151C5.47529 6.82547 6.2724 7.46302 7.25217 7.46302C8.23195 7.46302 9.02906 6.82547 9.02906 6.04151V1.06658C9.02942 0.757046 8.89544 0.463504 8.6616 0.260939Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.403022eb143bfc132d18e876f99b5f30.svg";
export { ForwardRef as ReactComponent };